export default [
    {
        path: 'relatorio-cota-consumo',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-cota-consumo' */
            '@/views/exame-laboratorial/relatorio-cota-consumo/Index'),
        redirect: 'relatorio-cota-consumo/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-cota-consumo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-cota-consumo' */
                    '@/views/exame-laboratorial/relatorio-cota-consumo/List.vue'),
            },
        ],
    },
]